import React, { useState } from 'react'
import { address, email, facebook_id, instagram_id, mobile_no, twitter_id, website_name, youtube_id } from '../../constants/themeConstants'
import { CgMenuLeftAlt } from "react-icons/cg";
import { Drawer } from 'antd'
import SideBar from './SideBar';
import { Churchlogo } from '../../constants/imageConstants';
import { useNavigate } from 'react-router-dom';
import { FaFacebookF,FaInstagram,FaTwitter,FaYoutube } from "react-icons/fa";
import { GrLocationPin } from "react-icons/gr";
import { MdOutlineEmail, MdOutlinePhone } from "react-icons/md";

function Footer() {
 const [menu,setmenu] = useState(false) 

 const navigate = useNavigate()

 const options = [
     {icon:FaFacebookF,path:facebook_id},
     {icon:FaInstagram,path:instagram_id},
    //  {icon:FaTwitter,path:twitter_id},
     {icon:FaYoutube,path:youtube_id},
 ]
 
 
  function openPage(){
   window.open(youtube_id, '_blank');
  }


  const menu1 = [
    {name:'Home',path:'/home'},
    {name:'About',path:'/about'},
    {name:'Services',path:'/services'},
    {name:'Contact',path:'/contact_us'},
    {name:'Location',path:'/location'},
  ]

  const menu2 = [
    {name:'Terms and Condition',path:'/terms_and_condition'},
    {name:'Privacy Policy',path:'/privacy_policy'}
  ]

  function openPageLink(path){
   navigate(path)
  }


  return (
    <div className='bg-slate-800 text-white'>
    <div className='w-[90%] px-2 grid grid-cols-1 md:grid-cols-4 gap-2  py-4 mx-auto'>
        <div className='w-[100%] md:border-r border-r-slate-700'>
          <img className='w-[50px]' src={Churchlogo} alt="logo" />
          <h5 className='text-[14px] text-[#c934b6] mt-4 font-heading font-[800]'>{website_name}</h5>
          <h5 className='text-[13px] text-white font-body font-[800]'>Unit of Immanuel Gospel Ministries</h5>
          <h6 className='font-body flex mt-2 items-start text-[13px]'><GrLocationPin className='mr-2 mt-1' /> {address}</h6>
          <h6 className='text-[12.5px] flex mt-1.5 items-start font-normal'><MdOutlinePhone className='mr-2 mt-[2px]' /> {mobile_no}</h6>
          <h6 className='text-[12.5px] flex mt-1.5 items-start font-normal'><MdOutlineEmail className='mr-2 mt-[2px]' /> {email}</h6>

         
        </div>

        <div className='pt-6 md:ml-4 md:border-r border-r-slate-700'>
          <h4 className='font-heading mb-2 text-[13.5px]'>Basic Menu</h4>
          {menu1?.map((m)=>(
            <h6 key={m?.name} onClick={()=>openPageLink(m?.path)} className='text-[13px] opacity-60 py-[3px] font-body hover:cursor-pointer hover:text-[#c934b6] hover:opacity-100'>{m?.name}</h6>
          ))}
        </div>

        <div className='pt-6 md:ml-4 md:border-r border-r-slate-700'>
          <h4 className='font-heading mb-2 text-[13.5px]'>Other Menu</h4>
          {menu2?.map((m)=>(
            <h6 key={m?.name} onClick={()=>openPageLink(m?.path)} className='text-[13px] opacity-60 py-[3px] font-body hover:cursor-pointer hover:text-[#c934b6] hover:opacity-100'>{m?.name}</h6>
          ))}
        </div>

        <div className='pt-6'>
          <h4 className='font-heading mb-2 md:ml-2 text-[13.5px]'>Follow Us</h4>
           <div className='flex items-center my-2 '>
          {options?.map((o)=>(
              <div onClick={()=>window.open(o?.path,'_blank')} key={o?.path}  className={`mx-1 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 active:scale-95 rounded flex item-center justify-center hover:bg-[#7b026b] p-1.5 hover:text-white`}>
                <o.icon size={14} />
              </div>    
          ))}
        </div>
        </div>

      
    </div>
      <h6 className='bg-slate-900 font-body text-center text-white p-1.5 text-white text-[10px]'>@2025-26 <span onClick={openPage} className='text-[#c934b6] font-[800] font-heading hover:cursor-pointer mx-1'> IGPH Kamalanagar </span> All Rights Reserved .</h6>
    </div>
  )
}

export default Footer